import { DeliverablePayload, LicenseFormPayload } from 'apis/LicenseApi';

export const DEFAULT_DELIVERABLE: DeliverablePayload = {
    contentIds: [],
    maxSeatsPerUser: 0,
    maxUses: 0,
    seats: 0,
    usesPerCode: 0
};

export const DEFAULT_FORM: LicenseFormPayload = {
    name: '',
    allowAssociate: 0,
    allowOffline: false,
    books: { ...DEFAULT_DELIVERABLE },
    courses: { ...DEFAULT_DELIVERABLE },
    licenseDuration: 0,
    licenseType: 1,
    practiceTests: { ...DEFAULT_DELIVERABLE },
    prefix: '',
    usageDays: 0
};

// Deliverable type constants — align with GMetrix.Data.Entities.Enums.EDeliverableType
export const DELIVERABLE_TYPE = { COURSE: 3, EBOOK: 2, PRACTICE_TEST: 1 } as const;